// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2I19l","title":"Images90_title__1_yKa","images":"Images90_images__17YIO"};